// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"53096":"4ae5e0dbd937f2ae","54551":"0e3c714e02c3b1f8","75075":"dcc5c1ba3d8ab5b6","96461":"084f1dee520a2ae8"}[chunkId] + ".css";
};